import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import { setBrightcoveAccountId } from "../../../../localstorage-service";
import { getConstants, updateConstant } from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import { showToastMessage, showSuccessToastMessage, showErrorToastMessage, emptyCheck } from "../../../../utilities";
import Spinner from "../../../User/Common/Spinner/Spinner";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";

class AdminConstant extends Component {
  state = {
    showSpinner: false,
    errorMessage: "",
    brightcoveAccountId: "",
    baseApiUrl: "",
    assignmentQuestions: "",
    assignmentPassPercent: "",
    showAssessmentResultVideos: "",
    streamLibrary: "",
    action: "edit"
  };
  componentDidMount() {
    this.getConstantsFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Constant");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }
  getConstantsFromService() {
    this.showSpinner(true);
    getConstants()
      .then(response => {
        this.showSpinner(false);
        this.setState({
          brightcoveAccountId: response.data[0].Value,
          baseApiUrl: response.data[1].Value,
          assignmentQuestions: response.data[2].Value,
          assignmentPassPercent: response.data[3].Value,
          showAssessmentResultVideos: response.data[4].Value,
          streamLibrary: response.data[5].Value
        });
      })
      .catch(error => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  }
  baseApiUrlChanged(e) {
    this.setState({
      baseApiUrl: e.target.value
    });
  }

  assignmentQuestionsChanged(e) {
    this.setState({
      assignmentQuestions: e.target.value
    });
  }
  assignmentPassPercentChanged(e) {
    this.setState({
      assignmentPassPercent: e.target.value
    });
  }
  brightcoveAccountChanged(e) {
    this.setState({
      brightcoveAccountId: e.target.value
    });
  }
  showAssessmentResultVideosChanged(e) {
    this.setState({
      showAssessmentResultVideos: e.target.value
    });
  }
  streamLibraryChanged(e) {
    this.setState({
      streamLibrary: e.target.value
    });
  }
  validate(data) {
    for (var i = 0; i < data.constants.length; i++) {
      if (emptyCheck(data.constants[i].Value)) {
        showToastMessage("error", `Error`, `Please enter ${data.constants[i].Name}`, this, "toastr1");
        return false;
      }
    }

    return true;
  }
  save() {
    this.setState({
      action: "edit"
    });
    const data = {
      constants: [
        {
          Id: 1,
          Name: "BrightcoveAccountId",
          Value: this.state.brightcoveAccountId
        },
        {
          Id: 2,
          Name: "BaseApiUrl",
          Value: this.state.baseApiUrl
        },
        {
          Id: 3,
          Name: "AssignmentQuestions",
          Value: this.state.assignmentQuestions
        },
        {
          Id: 4,
          Name: "PassPercentage",
          Value: this.state.assignmentPassPercent
        },
        {
          Id: 5,
          Name: "ShowAssessmentResultVideos",
          Value: this.state.showAssessmentResultVideos
        },
        {
          Id: 6,
          Name: "MSStreamLink",
          Value: this.state.streamLibrary
        }
      ]
    };
    if (this.validate(data)) {
      this.updateConstants(data);
    }
  }

  updateConstants(data) {
    this.showSpinner(true);
    updateConstant(data)
      .then(response => {
        this.showSpinner(false);
        this.showSuccessMessage("Constants");
        setBrightcoveAccountId(data.constants[0].Value);
      })
      .catch(error => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  }

  render() {
    return (
      <Aux>
        <h1 className="page-header">Constants</h1>
        <AdminBreadcrumb data={[{ name: "Home", link: "/admin/modules/" }, { name: "Constants" }]} />
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        {/* <div className="form-group">
          <label className="pull-left">
            <RequiredField />Brightcove AccountId:{" "}
          </label>
          <input
            type="text"
            className="form-control"
            ref="txtBrightcoveAccountId"
            value={this.state.brightcoveAccountId}
            onChange={e => this.brightcoveAccountChanged(e)}
          />
        </div> */}
        {/* <div className="form-group">
          <label className="pull-left">
            <RequiredField />
            Api Url:{" "}
          </label>
          <input
            type="text"
            className="form-control"
            value={this.state.baseApiUrl}
            onChange={e => this.baseApiUrlChanged(e)}
          />
        </div> */}
        <div className="form-group">
          <label className="pull-left">
            <RequiredField />
            Self Assessment Questions:{" "}
          </label>
          <input
            type="text"
            className="form-control"
            value={this.state.assignmentQuestions}
            onChange={e => this.assignmentQuestionsChanged(e)}
          />
        </div>
        <div className="form-group">
          <label className="pull-left">
            <RequiredField />
            Self Assessment Pass Percentage:{" "}
          </label>
          <input
            type="text"
            className="form-control"
            value={this.state.assignmentPassPercent}
            onChange={e => this.assignmentPassPercentChanged(e)}
          />
        </div>
        <div className="form-group">
          <label className="pull-left">
            <RequiredField />
            Show Assessment Result Videos (Enter either 1 or 0):{" "}
          </label>
          <input
            type="text"
            className="form-control"
            value={this.state.showAssessmentResultVideos}
            onChange={e => this.showAssessmentResultVideosChanged(e)}
          />
        </div>
        {/* <div className="form-group">
          <label className="pull-left">
            <RequiredField />
            MS Stream Library Link:{" "}
          </label>
          <input
            type="text"
            className="form-control"
            value={this.state.streamLibrary}
            onChange={e => this.streamLibraryChanged(e)}
          />
        </div> */}
        <button className="btn btn-primary" onClick={() => this.save()}>
          Save
        </button>
      </Aux>
    );
  }
}

export default AdminConstant;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Constant/Constant.js